import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const plannerLocaleModule: LocaleModule = {
  name: "planner",
  messages: { en: en, it: it },
};
